import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import BasicDatePicker from './BasicDatePicker';
import { SERVER_URL } from '../constants';
import { formatDateObjectToString, formatDate } from '../helpers/Helpers';
import { Divider, Stack } from '@mui/material';
import QrCode from './QrCode';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AppLinkCopyButton from './AppLinkCopyButton';
import AppLinkCopyCodeButton from './AppLinkCopyCodeButton';
import SocialMediaShare from './SocialMediaShare';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const minSliderValue = 2;
// const defaultSliderValue = 10;

function GenerateSchedLink (props) {

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        setMaxAppointments(10);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
        setAppLink("");
        setIsClicked(false);
        setDisableDatePicker(false);
        setDisableSlider(false);
        if (typeof props.fetchOffices === 'function') {
            props.fetchOffices();
        }
        if (typeof props.fetchSchedulesList === 'function') {
            props.fetchSchedulesList(date);
        }
        props.setRecentAppLinkGenerate(true);
    };

    const onGenerateCodeClick = () => {
        if(!isClicked) setIsClicked(true);
        fetchSchedLink();
    };

    const [date, setDate] = useState(dayjs(props.rawDate));

    const [disableGenerateButtton, setDisableGenerateButton] = useState(true);

    useEffect(() => {
        setDisableGenerateButton(true);
    }, [open]);


    const handleDateChange = (date) => {
        setDate(date);
        if (date) setDisableGenerateButton(false);
    };

    const [appLink, setAppLink] = useState("");

    const [copyMessage, setCopyMessage] = useState("");

    useEffect(() => {
        setCopyMessage("You're invited to go to " + props.officeName + " for an appointment. To see the details and confirm your appointmment, please sign in to APP . QONSULTA . NET on your phone's Chrome browser and enter this APPOINTMENT CODE: " + appLink.split("/")[3]);
    }, [appLink]);

    const [isClicked, setIsClicked] = useState(false);

    const [disableDatePicker, setDisableDatePicker] = useState(false);

    const [maxAppointments, setMaxAppointments] = useState(10);

    const [disableSlider, setDisableSlider] = useState(false);

    const handleChange = (event) => {
        const value = event.target.value;
        // Allow empty string or any numeric input while typing
        if (/^\d*$/.test(value)) {
            setMaxAppointments(value);
        }
    };

    const handleBlur = () => {
        const num = Number(maxAppointments);
        if (num < 2) {
            setMaxAppointments('2');
        } else if (num > 100) {
            setMaxAppointments('100');
        }
    };



    const handleSliderChange = (event, newValue) => {
        setMaxAppointments(String(newValue));
    };


    const fetchSchedLink = () => {
        const requestData = {
            "office_id": props.officeId,
            "date": formatDateObjectToString(new Date(date.toString()))
        };
        // console.log("fetchSchedLink", requestData);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/create-schedlink', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            setAppLink(data.data.link);
            setDisableDatePicker(true);
            setDisableSlider(true);
            if (typeof props.fetchOffices === 'function') {
                props.fetchOffices();
            }
            if (typeof props.fetchSchedulesList === 'function') {
                props.fetchSchedulesList(date);
            }
        })
        .catch(err => console.error(err));
    }

    return(
        <React.Fragment>
            <Button
                variant='text'
                onClick={handleClickOpen}
                sx={{
                    mr: 2,
                    border: '1px solid',
                    borderColor: 'primary.main',
                    borderRadius: 1, // optional: for rounded corners
                    paddingX: 2, // optional: horizontal padding
                    paddingY: 1, // optional: vertical padding
                    width: 200,
                }}
            >
                Locked Date <br /> {props.rawDate}
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2, lineHeight: 1.2 }} id="customized-dialog-title">
                    <Typography sx={{ lineHeight: 1.2 }}>
                        Locked Date Code
                    </Typography>
                    <Typography variant="body1">
                        {props.officeName}
                    </Typography>
                </DialogTitle>
                <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
                >
                <CloseIcon />
                </IconButton>
                <DialogContent sx={{minWidth: 260}} dividers={true}>
                    <Stack direction="column" justifyContent="center" alignItems='left' spacing={2}>
                        <Typography gutterBottom variant="body1">
                            User will be locked to a Dynamic Queue on this date:
                        </Typography>
                        <BasicDatePicker disabled={true} value={date} onChange={handleDateChange} />
                        {/* <Box sx={{ m: 0, p: 2 }}>
                            <TextField
                                name="notes"
                                value={maxAppointments}
                                id="outlined-multiline-static"
                                label="Max Users"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 3 }}
                                onChange={handleChange}
                                onBlur={handleBlur}

                            />

                            <Slider
                                value={Number(maxAppointments)}
                                aria-label="Max Users"
                                valueLabelDisplay="auto"
                                min={minSliderValue}
                                max={100}
                                onChange={handleSliderChange}
                                disabled={disableSlider}
                            />
                        </Box> */}
                        
                        <Stack direction="row" justifyContent="center" alignItems='center' spacing={0}>
                            {appLink !== "" ? <React.Fragment><Typography variant="h4">{appLink.split("/")[3]}</Typography><AppLinkCopyCodeButton appLink={appLink.split("/")[3]}/></React.Fragment> : null}
                        </Stack>
                        
                    </Stack>
                    <Stack direction="row" justifyContent="center" alignItems='center' spacing={2}>
                        {appLink !== "" ? <QrCode code={appLink.split("/")[3]} date={formatDateObjectToString(new Date(date.toString()))} officeName={props.officeName} string={appLink}/> : null}
                        {appLink !== "" ? <AppLinkCopyButton appLink={copyMessage}/> : null}
                    </Stack>

                    {/* {appLink !== "" ? <Divider sx={{padding: 1}} /> : null}

                    <Stack direction="column" justifyContent="center" alignItems='center' spacing={2}>
                    {appLink !== "" ? <Typography gutterBottom variant="body1">Share through:</Typography> : null}
                    </Stack>
                        
                    <Stack direction="row" justifyContent="center" alignItems='center' spacing={2}>
                        {appLink !== "" ? <SocialMediaShare appLink={copyMessage} /> : null} 
                    </Stack> */}
                </DialogContent>
                <DialogActions>
                    {appLink === "" ? <Button disabled={isClicked} onClick={handleClose}>Cancel</Button> : null}
                    {appLink === "" ? <Button disabled={isClicked} autoFocus onClick={onGenerateCodeClick}>Generate Code</Button> : null}
                    {appLink !== "" ? <Button autoFocus onClick={handleClose}>Done</Button> : null}
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default GenerateSchedLink;